// extracted by mini-css-extract-plugin
module.exports = {"button":"e_45","inner":"e_55","innerText":"e_65"};